import React from "react";
import PropTypes from "prop-types";
import { Grid, Box } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { performanceCardStyles } from "../styles/PerformanceCard.styles";

const OBJECT_IDS = {
  PERFORMANCE_TOTAL: "xmEV",
  PERFORMANCE_CATEGORIES: "MUgngWu",
};

const PerformanceCard = ({ app }) => {
  return (
    <Card
      app={app}
      header={{
        hardTitle: "Desempenho",
      }}
      className="card"
      tooltipText="🔴: Abaixo de 95% 🟡: De 95% a 99,99% 🟢: Maior ou Igual a 100%"
    >
      <Box sx={performanceCardStyles.wrapper}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <NativeObject
              app={app}
              key={OBJECT_IDS.PERFORMANCE_TOTAL}
              reference={{ id: OBJECT_IDS.PERFORMANCE_TOTAL }}
              style={performanceCardStyles.totalTable}
            />
          </Grid>
          <Grid item xs={12}>
            <NativeObject
              app={app}
              key={OBJECT_IDS.PERFORMANCE_CATEGORIES}
              reference={{ id: OBJECT_IDS.PERFORMANCE_CATEGORIES }}
              style={performanceCardStyles.categoriesTable}
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

PerformanceCard.propTypes = {
  app: PropTypes.object.isRequired,
};

export default PerformanceCard;
